import { AppDispatch, RootState, store } from '../index';
import { FetchState } from '../fetchState';
import { getList, getListSort, ListFilter, listSlice, ListType } from '../listHelper';
import { CancelToken } from 'axios';
import { DateFromTo } from '../../models/common';
import { entryRequestService } from '@api/services/services';
import { EntryRequestDto } from '@api/models/invitation/EntryRequestDto';
import { EntryRequestState } from '@api/models/enums/EntryRequestState';
import { getDateForApi } from '../../utils/date';
import { ReferenceDto } from '@api/models/employees/ReferenceDto';

export interface EntryRequestListFilter extends ListFilter {
  supplier?: ReferenceDto[];
  invitation?: ReferenceDto[];
  state?: EntryRequestState[];
  responsiblePersonCompany?: ReferenceDto[];
  dateRange?: DateFromTo;
}

export type EntryRequestListState = ListType<EntryRequestDto, EntryRequestListFilter>;

const initialState: EntryRequestListState = {
  state: FetchState.None,
  data: undefined,
  query: {
    sortBy: 'dateFrom',
    sortDesc: false,
    dateRange: {
      from: new Date(),
    },
  },
};

export const entryRequestListSlice = listSlice({
  name: 'entryRequestList',
  initialState,
});

export const selectEntryRequestList = (state: RootState) => state.entryRequestList;
export const entryRequestListActions = entryRequestListSlice.actions;

export const getEntryRequestList =
  (cancelToken: CancelToken, invitationId?: string) => (dispatch: AppDispatch) => {
    const storeState = store.getState();
    const data = selectEntryRequestList(storeState);

    const handleGetData = (size: number) => {
      return entryRequestService.getEntryRequestsByCompany({
        suppliers: data.query.supplier?.map(it => it.id),
        invitations: invitationId ? [invitationId] : data.query.invitation?.map(it => it.id),
        responsiblePersonCompany: data.query.responsiblePersonCompany?.map(it => it.id),
        state: data.query.state,
        dateFrom: getDateForApi(data.query.dateRange?.from),
        dateTo: getDateForApi(data.query.dateRange?.to),
        page: data.query.page,
        size,
        sort: getListSort(data),
      }, {
        cancelToken: cancelToken
      });
    };

    getList({
      dispatch,
      cancelToken,
      state: data.state,
      actions: entryRequestListActions,
      getData: handleGetData,
    });
  };
